enum Type {
  Link = "Link",
  Entry = "Entry",
  Asset = "Asset",
}

enum LinkType {
  Entry = "Entry",
  Asset = "Asset",
  User = "User",
  Space = "Space",
  Environment = "Environment",
  ContentType = "ContentType",
}

interface Sys {
  type: Type;
  id: string;
}

interface Metadata {
  tags: string[];
}

interface LinkSys extends Sys {
  type: typeof Type.Link;
  linkType: LinkType;
}

interface EntrySys extends Sys {
  type: typeof Type.Entry;
  contentType: Link;
}

interface AssetSys extends Sys {
  type: typeof Type.Asset;
}

interface Fields {
  [key: string]: {
    ['en-US']: any;
  };
}

export interface Link {
  sys: LinkSys;
}

export interface Entry {
  sys: EntrySys;
  fields: Fields;
  metadata: Metadata;
}

export interface Asset {
  sys: AssetSys;
  fields: {
    title: {
      ['en-US']: string;
    };
    description: {
      ['en-US']: any;
    },
    file: {
      ['en-US']: File;
    };
  };
  metadata: Metadata;
}

export interface Area extends Entry {
  fields: {
    name: {
      ['en-US']: string;
    };
    points: {
      ['en-US']: Link[];
    };
    radius: {
      ['en-US']: number;
    };
    model: {
      ['en-US']: Link;
    };
    audio: {
      ['en-US']: Link;
    };
    distanceFromTheSun: {
      ['en-US']: number;
    };
    symbol: {
      ['en-US']: Link;
    };
    cameraPositionX: {
      ['en-US']: number;
    };
    cameraPositionY: {
      ['en-US']: number;
    };
    cameraPositionZ: {
      ['en-US']: number;
    };
    cameraTargetX: {
      ['en-US']: number;
    };
    cameraTargetY: {
      ['en-US']: number;
    };
    cameraTargetZ: {
      ['en-US']: number;
    };
    content: any;
  }
}

export interface Point extends Entry {
  fields: {
    name: {
      ['en-US']: string;
    };
    content: {
      ['en-US']: any;
    };
    audio: {
      ['en-US']: Link;
    };
  };
}

export interface Settings extends Entry {
  fields: {
    backgroundTextureImage: {
      ['en-US']: Link;
    };
    credits: any;
  };
}

export interface File {
  url: string;
  details: {
    size: number;
  };
  fileName: string;
  contentType: string;
}
